export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 200;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 60;
export const TOP_NAV_HEIGHT = 60;
export const THEME_TYPE_LIGHT = 'light';
export const THEME_TYPE_DARK = 'dark';
export const NAV_TYPE_SIDE = 'SIDE';
export const NAV_TYPE_TOP = 'TOP';
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';

export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#ffffff';
export const HEADER_BG_DEFAULT_COLOR_DARK = '#283142';
export const LAYOUT_CONTENT_GUTTER = 25;
export const LAYOUT_CONTENT_GUTTER_SM = 15;
export const SIDE_NAV_DARK_BG_COLOR = '#001529';

// base colors
export const BLUE_BASE = '#0984E3';
export const PURPLE_BASE = '#a461d8';
export const CYAN_BASE = '#04d182';
export const GREEN_BASE = '#39c648';
export const MOSSY_GREEN_BASE = '#216124';
export const MAGENTA_BASE = '#eb2f96';
export const PINK_BASE = '#eb2f96';
export const RED_BASE = '#e04c4c';
export const ORANGE_BASE = '#fa8c16';
export const YELLOW_BASE = '#fadb14';
export const VOLCANO_BASE = '#ff6b72';
export const GEEK_BLUE_BASE = '#17bcff';
export const LIME_BASE = '#a0d911';
export const GOLD_BASE = '#deb509';

//gray scale colors
export const WHITE = '#ffffff';
export const DARK = '#000000';
export const GRAY_DARK = '#1a3353';
export const GRAY = '#455560';
export const GRAY_MILD = '#778e9d';
export const GRAY_LIGHT = '#cbd1da';
export const GRAY_LIGHTER = '#ededed';
export const GRAY_LIGHTEST = '#f7f7f8';

// Was '#f7fdfe' — close enough to white Card backgrounds that cards barely
// stood out from the page behind them.
export const BODY_BACKGROUND = '#f0f2f5';

// Type scale. 12px is the floor for any readable text.
export const FONT_SIZE_SM = 12; // captions, meta text, tags
export const FONT_SIZE_BASE = 14; // body text
export const FONT_SIZE_LG = 16; // section titles
export const FONT_SIZE_XL = 20; // page titles

// Text colours. Each meets WCAG AA (4.5:1) on white, BODY_BACKGROUND and the
// light `${color}18` tints used behind status tags. The *_BASE colours are too
// light to read as text — keep those for icons, fills, borders and charts.
export const TEXT_SECONDARY = '#5f6b7a';
export const BLUE_TEXT = '#0b62b0';
export const GREEN_TEXT = '#237804';
export const ORANGE_TEXT = '#ad4e00';
export const RED_TEXT = '#c0392b';
export const GOLD_TEXT = '#876800';
export const CYAN_TEXT = '#00754a';
export const PURPLE_TEXT = '#7b3fb3';

const TEXT_SHADE = {
  [BLUE_BASE]: BLUE_TEXT,
  [GREEN_BASE]: GREEN_TEXT,
  [ORANGE_BASE]: ORANGE_TEXT,
  [RED_BASE]: RED_TEXT,
  [GOLD_BASE]: GOLD_TEXT,
  [YELLOW_BASE]: GOLD_TEXT,
  [CYAN_BASE]: CYAN_TEXT,
  [PURPLE_BASE]: PURPLE_TEXT,
  [GRAY_LIGHT]: TEXT_SECONDARY,
  [GRAY_MILD]: TEXT_SECONDARY,
};

// Readable text shade for a base colour — use wherever a status/track colour
// is applied to text (e.g. `color: readableText(cfg.color)` on a tinted tag).
export const readableText = (color) => TEXT_SHADE[color] || color;

export const TEMPLATE = {
  HEADER_HEIGHT,
  FOOTER_HEIGHT,
  TOP_NAV_HEIGHT,
  CONTENT_HEIGHT_OFFSET,
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_DARK_BG_COLOR,
  CONTENT_MAX_WIDTH,
  HEADER_BG_DEFAULT_COLOR_LIGHT,
  HEADER_BG_DEFAULT_COLOR_DARK,
  LAYOUT_CONTENT_GUTTER,
  LAYOUT_CONTENT_GUTTER_SM,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  THEME_TYPE_LIGHT,
  THEME_TYPE_DARK,
  DIR_LTR,
  DIR_RTL,
};

export const THEME_COLOR = {
  BLUE: BLUE_BASE,
  PURPLE: PURPLE_BASE,
  CYAN: CYAN_BASE,
  GREEN: GREEN_BASE,
  MAGENTA: MAGENTA_BASE,
  PINK: PINK_BASE,
  RED: RED_BASE,
  ORANGE: ORANGE_BASE,
  YELLOW: YELLOW_BASE,
  VOLCANO: VOLCANO_BASE,
  GEEK_BLUE: GEEK_BLUE_BASE,
  LIME: LIME_BASE,
  GOLD: GOLD_BASE,
};
export const COLORS = [
  BLUE_BASE,
  PURPLE_BASE,
  CYAN_BASE,
  GREEN_BASE,
  MAGENTA_BASE,
  PINK_BASE,
  RED_BASE,
  ORANGE_BASE,
  YELLOW_BASE,
  VOLCANO_BASE,
  GEEK_BLUE_BASE,
  LIME_BASE,
  GOLD_BASE,
];
// Was '#e6ebf1' — nearly indistinguishable from a white/BODY_BACKGROUND page,
// making every Input/Select border (wired as the global antd colorBorder
// token below) look like it had no box at all.
export const BORDER = {
  BASE_COLOR: GRAY_LIGHT,
};

export const GRAY_SCALE = {
  DARK,
  WHITE,
  GRAY_DARK,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTER,
  GRAY_LIGHTEST,
};

export const DARK_MODE = {
  TEXT_COLOR: '#b4bed2',
  HEADING_COLOR: '#d6d7dc',
  BG_COLOR: '#283142',
  BORDER_BASE_COLOR: '#4d5b75',
  HOVER_BG_COLOR: '#364663',
  ACTIVE_BG_COLOR: '#293956',
  DROP_DOWN_SHADOW:
    '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 58%), 0 9px 28px 8px rgb(0 0 0 / 15%)',
};
